// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['ro_RO']  = {
    "name": "ro_RO",
    "day": {
        "abbrev": [
            "dum.",
            "lun.",
            "mar.",
            "mie.",
            "joi.",
            "vin.",
            "sâm."
        ],
        "full": [
            "duminică",
            "luni",
            "marți",
            "miercuri",
            "joi",
            "vineri",
            "sâmbăta"
        ]
    },
    "month": {
        "abbrev": [
            "ian.",
            "feb.",
            "mar.",
            "apr.",
            "mai.",
            "iun.",
            "iul.",
            "aug.",
            "sep.",
            "oct.",
            "noi.",
            "dec."
        ],
        "full": [
            "ianuarie",
            "februarie",
            "martie",
            "aprilie",
            "mai",
            "iunie",
            "iulie",
            "august",
            "septembrie",
            "octombrie",
            "noiembrie",
            "decembrie"
        ]
    },
    "meridiem": [
        "",
        ""]
    ,
    "date": "%d.%m.%Y",
    "time24": "%T",
    "dateTime": "%a %d %B %Y %T %Z",
    "time12": "",
    "full": "%a, %-d %B %T %Y %Z"
}

